console.log('init quiz.js')

localStorage.setItem('quizStep', '1');

window.$quiz = {
    currentStep: localStorage.getItem('quizStep') ?? 1,
    allQuestions: [
        {
            name: "What is your favorite ice cream flavor?",
            icon: "https://cdn.shopify.com/s/files/1/0278/2684/7789/files/Group.svg?v=1664297696",
            questions: [
                {
                    text: "Rocky Road",
                    value: "Chocolate"
                },
                {
                    text: "Strawberry Sherbet",
                    value: "Fruity"
                },
                {
                    text: "Vanilla Bean",
                    value: "Sweet Tooth"
                },
                {
                    text: "Peanut Butter Brittle",
                    value: "Sweet & Salty"
                },
                {
                    text: "Pumpkin Spice",
                    value: "Spice"
                }
            ],
            answer: localStorage.getItem('quizStepAnswer1') ?? ""
        },
        {
            name: "Pick an ice cream topping:",
            icon: "https://cdn.shopify.com/s/files/1/0278/2684/7789/files/icon_2.svg?v=1663947071",
            questions: [
                {
                    text: "Fudge Sauce",
                    value: "Chocolate"
                },
                {
                    text: "Fresh Fruit",
                    value: "Fruity"
                },
                {
                    text: "Sprinkles",
                    value: "Sweet Tooth"
                },
                {
                    text: "Salted Caramel",
                    value: "Sweet & Salty"
                },
                {
                    text: "Cinnamon Streusel",
                    value: "Spice"
                }
            ],
            answer: localStorage.getItem('quizStepAnswer2') ?? ""
        },
        {
            name: "What is your favorite dessert?",
            icon: "https://cdn.shopify.com/s/files/1/0278/2684/7789/files/icon_3.svg?v=1663947071",
            questions: [
                {
                    text: "Brownies",
                    value: "Chocolate"
                },
                {
                    text: "Strawberry Rhubarb Pie",
                    value: "Fruity"
                },
                {
                    text: "Confetti Cake",
                    value: "Sweet Tooth"
                },
                {
                    text: "Cheesecake",
                    value: "Sweet & Salty"
                },
                {
                    text: "Pumpkin Pie",
                    value: "Spice"
                }
            ],
            answer: localStorage.getItem('quizStepAnswer3') ?? ""
        },
        {
            name: "What is your favorite candy?",
            icon: "https://cdn.shopify.com/s/files/1/0278/2684/7789/files/icon_4.svg?v=1663947071",
            questions: [
                {
                    text: "Snickers",
                    value: "Chocolate"
                },
                {
                    text: "Skittles",
                    value: "Fruity"
                },
                {
                    text: "Cotton Candy",
                    value: "Sweet Tooth"
                },
                {
                    text: "Pay Day",
                    value: "Sweet & Salty"
                },
                {
                    text: "Hot Tamales",
                    value: "Spice"
                }
            ],
            answer: localStorage.getItem('quizStepAnswer4') ?? ""
        },
        {
            name: "Pick a donut:",
            icon: "https://cdn.shopify.com/s/files/1/0278/2684/7789/files/icon_5.svg?v=1663947072",
            questions: [
                {
                    text: "Chocolate Frosted Donut",
                    value: "Chocolate"
                },
                {
                    text: "Blueberry Cake Donut",
                    value: "Fruity"
                },
                {
                    text: "Glazed",
                    value: "Sweet Tooth"
                },
                {
                    text: "Maple Bacon",
                    value: "Sweet & Salty"
                },
                {
                    text: "Apple Fritter",
                    value: "Spice"
                }
            ],
            answer: localStorage.getItem('quizStepAnswer5') ?? ""
        },
        {
            name: "What is your favorite cereal?",
            icon: "https://cdn.shopify.com/s/files/1/0278/2684/7789/files/Asset_9_1.svg?v=1664299460",
            questions: [
                {
                    text: "Cocoa Pebbles",
                    value: "Chocolate"
                },
                {
                    text: "Froot Loops",
                    value: "Fruity"
                },
                {
                    text: "Lucky Charms",
                    value: "Sweet Tooth"
                },
                {
                    text: "Raisin Bran",
                    value: "Sweet & Salty"
                },
                {
                    text: "Cinnamon Toast Crunch",
                    value: "Spice"
                }
            ],
            answer: localStorage.getItem('quizStepAnswer6') ?? ""
        },
        {
            name: "Pick a midnight snack:",
            icon: "https://cdn.shopify.com/s/files/1/0278/2684/7789/files/icon_7.svg?v=1663947071",
            questions: [
                {
                    text: "Chocolate Chip Cookies",
                    value: "Chocolate"
                },
                {
                    text: "Fruit Snacks",
                    value: "Fruity"
                },
                {
                    text: "Ice Cream",
                    value: "Sweet Tooth"
                },
                {
                    text: "Potato Chips",
                    value: "Sweet & Salty"
                },
                {
                    text: "Cinnamon Roll",
                    value: "Spice"
                }
            ],
            answer: localStorage.getItem('quizStepAnswer7') ?? ""
        }
    ]
};

class Quiz {
    constructor() {

    }

    init() {
        let currentStep = window.$quiz.currentStep;

        //render step
        this.renderStep(currentStep);

        //add listeners for buttons
        this.prevStepButtonListener(currentStep);
        this.nextStepButtonListener(currentStep);
    }

    renderStep(currentStep, prevStep = false) {
        this.addLoader();

        setTimeout(() => {
            this.renderStepProgressBarText(currentStep);
            this.renderStepProgressBar(currentStep, prevStep);
            this.renderQuestion(currentStep);
            this.renderAnswers(currentStep);
            this.renderButtons(currentStep);

            setTimeout(() => {
                this.removeLoader();
            }, 500);
        }, 500);
    }

    removeLoader() {
        let container = document.getElementById('container');

        container.classList.remove('transparent');
    }

    addLoader() {
        let container = document.getElementById('container');

        container.classList.add('transparent');
    }

    renderStepProgressBarText(currentStep) {
        let stepText = document.getElementById('stepText');

        stepText.innerText = currentStep + '/7';
    }

    renderStepProgressBar(currentStep, prevStep = false) {
        let progressBar = document.getElementById('progressBar');
        let currentStepClassName = '';

        switch (currentStep) {
            case "1":
                currentStepClassName = 'one';
                break;
            case "2":
                currentStepClassName = 'two';
                break;
            case "3":
                currentStepClassName = 'three';
                break;
            case "4":
                currentStepClassName = 'four';
                break;
            case "5":
                currentStepClassName = 'five';
                break;
            case "6":
                currentStepClassName = 'six';
                break;
            case "7":
                currentStepClassName = 'seven';
                break;
        }

        if (prevStep) {
            let classListLength = progressBar.classList.length;

            progressBar.classList.remove(progressBar.classList[classListLength - 1]);
        }

        progressBar.classList.add(currentStepClassName);
    }

    renderQuestion(currentStep) {
        let question = document.getElementById('quizQuestion');
        let currentQuestion = window.$quiz.allQuestions[currentStep - 1];

        question.innerHTML = `
            <img src="${currentQuestion.icon}" alt="icon">

            ${currentQuestion.name}
        `;
    }

    renderAnswers(currentStep) {
        let currentQuestion = window.$quiz.allQuestions[currentStep - 1];
        let questions = document.querySelectorAll('#questionsWrapper .question');

        questions.forEach((q, index) => {
            let label = q.querySelector('label');
            let input = q.querySelector('input');

            label.querySelector('p').innerText = currentQuestion.questions[index].text;
            input.value = currentQuestion.questions[index].value;

            if (currentQuestion.answer == currentQuestion.questions[index].value) {
                input.checked = true;
            }
        });
    }

    renderButtons(currentStep) {
        if (currentStep == 1) {
            document.getElementById("prevButton").style.display = 'none';
        } else {
            document.getElementById("prevButton").style.display = 'block';
        }
    }

    prevStepButtonListener() {
        let prevStepButton = document.getElementById('prevButton');

        prevStepButton.addEventListener('click', (e) => {
            e.preventDefault();

            let currentStep = parseInt(localStorage.getItem('quizStep')) - 1;

            if (currentStep > 0 && currentStep < 8) {
                this.renderStep( `${currentStep}`, true);
                localStorage.setItem('quizStep', `${currentStep}`);
            } else {
                console.log('STOP!');
            }
        });
    }

    nextStepButtonListener() {
        let nextStepButton = document.getElementById('nextButton');

        nextStepButton.addEventListener('click', (e) => {
            e.preventDefault();

            let currentStep = parseInt(localStorage.getItem('quizStep'));
            let currentStepPlus = currentStep + 1;
            let result = document.querySelector("#questionsWrapper .question input:checked");
            let errorsWrapper = document.getElementById('errors');

            if (!result) {
                errorsWrapper.classList.remove('hid');
            } else {
                errorsWrapper.classList.add('hid');
                localStorage.setItem(`quizStepAnswer${currentStepPlus}`, `${result.value}`);

                if (currentStep == 7) {
                    console.log('Quiz results');
                    nextStepButton.style.pointerEvents = 'none';

                    window.location.href = '/pages/quiz-results';
                } else {
                    window.$quiz.allQuestions[currentStep - 1].answer = `${result.value}`;
                    this.renderStep(`${currentStepPlus}`);
                    this.clearCheckedVariants();
                    localStorage.setItem('quizStep', `${currentStepPlus}`);
                }
            }
        });
    }

    clearCheckedVariants() {
        let variants = document.querySelectorAll("#questionsWrapper .question input");

        variants.forEach(variant => {
            variant.checked = false;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new Quiz().init();
});